'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./accordion.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Accordion Component.
 * Due to the complexity of margins and their potentially collapsible nature, ReactCollapse does not support (vertical)
 * margins on their children. It might lead to the animation "jumping" to its correct height at the end of expanding.
 * To avoid this, use padding instead of margin.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */

var Accordion = function (_Component) {
    (0, _inherits3.default)(Accordion, _Component);

    function Accordion(props) {
        (0, _classCallCheck3.default)(this, Accordion);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Accordion.__proto__ || (0, _getPrototypeOf2.default)(Accordion)).call(this, props));

        _this.handleOnClick = function () {
            _this.setState({ isOpen: !_this.state.isOpen });
        };

        _this.state = {
            isOpen: props.isOpen || false
        };
        return _this;
    }

    (0, _createClass3.default)(Accordion, [{
        key: 'render',
        value: function render() {
            var _cx,
                _this2 = this;

            var _props = this.props,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                _props$id = _props.id,
                id = _props$id === undefined ? '' : _props$id,
                children = _props.children,
                _props$style = _props.style,
                style = _props$style === undefined ? '' : _props$style;
            var isOpen = this.state.isOpen;


            var classNames = (0, _classnames2.default)((_cx = {
                'sb-accordion': true,
                'sb-accordion--is-open': isOpen
            }, (0, _defineProperty3.default)(_cx, 'sb-accordion--' + style, style), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

            var childrenWithProps = _react2.default.Children.map(children, function (child) {
                if (child.type && child.type.name === 'AccordionTitle') {
                    return _react2.default.cloneElement(child, {
                        onClick: _this2.handleOnClick
                    });
                }
                return _react2.default.cloneElement(child, {
                    isOpen: isOpen
                });
            });

            return (0, _jsx3.default)('section', {
                className: classNames,
                id: id
            }, void 0, childrenWithProps);
        }
    }]);
    return Accordion;
}(_react.Component);
// css


exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/accordion/Accordion.js
// module id = 541
// module chunks = 0